export enum TypeStatements {
    Call = "call",
    Result = "result",
    Error = "error",
}
